export default "__VITE_ASSET__C_E4dKWx__"